import { Card } from 'antd';

interface CardBoxProps {
  bodyStyle?: any;
  content: any;
  extra?: any;
  loading?: boolean;
  title: any;
}

const CardBox = ({
  bodyStyle = {},
  content,
  extra,
  loading,
  title,
}: CardBoxProps) => (
  <Card
    className="accented-shadow"
    extra={extra}
    loading={!!loading}
    styles={{ body: bodyStyle }}
    title={title}
  >
    {content}
  </Card>
);

export default CardBox;
